const styles = {
  text: {
    height: '200px'
  }
}

export default styles
